module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedMedium.fe5fc50.woff2";